import * as React from 'react';
import { ReleaseFollowUp } from '../../../amorg-common';
import { articlesClientApi } from '../../../api/articlesClientApi';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { MessageCard } from '../../../designSystem/Message';
import { Table } from '../../../designSystem/Table';
import { Strong } from '../../../designSystem/typography/Body';
import { H1 } from '../../../designSystem/typography/Heading';
import { ArticlesTab } from './_components/ArticlesTab';
import { AmorgyPageWrapper } from '../../_pageWrappers/AmorgyPageWrapper';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';

export default function ArticlesFollowUp (): JSX.Element 
{
    const [loading, setLoading] = React.useState<boolean>(true);
    const [followups, setFollowups] = React.useState<ReleaseFollowUp[]>([]);

    React.useEffect(() =>
    {
        document.title = 'Amorgy - Lovkrav opfølgning';
        const getData = async () =>
        {
            const followups = await articlesClientApi.getFollowups();
            setFollowups(followups);
            setLoading(false);
        };
        getData();
    }, []);

    return (
        <AmorgyPageWrapper selectedTab='articles'
            subMenuContent={
                <ArticlesTab selectedTab='followup' />
            }>
            <LoadingPageOverlay loading={false} />
            <SingleColumnLayout narrow>

                    <Flex flexDirection='column' gap={16}>

                        <LoadingPageOverlay loading={loading} />

                        <H1>Opfølgning på manglende evaluering</H1>

                        <MessageCard variant='info'>
                            Listen viser lovkrav hvor kunden enten ikke har evalueret artiklen eller har valgt <i>Ingen evaluering foretaget</i>
                        </MessageCard>

                        <Table>
                            <thead>
                                <tr>
                                    <th>Virksomhed</th>
                                    <th>Artikel</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {followups.length === 0 &&
                                    <tr>
                                        <td colSpan={4}>Ingen opfølgning</td>
                                    </tr>
                                }
                                {followups.map(followup => (
                                    <tr key={followup.releaseRecordId}>
                                        <td>{followup.subscriber.companyName || followup.subscriber.siteId}</td>
                                        <td>
                                            <Strong>{followup.list.name} -&gt; {followup.topic.name}</Strong>
                                            <div>{followup.articleTitle}</div>
                                        </td>
                                        <td>
                                            <LinkButton variant='text' text="Vis artikel" href={`${followup.articleId}`} target='_blank' />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Flex>
            </SingleColumnLayout>

        </AmorgyPageWrapper>
    );
}
